import { createContext, useContext, useEffect, useState } from 'react';

const defaultTheme = {
	logo: 'palary',
	logoUrl: null,
	primaryColor: '#30302F',
	secondaryColor: '#C2F734',
	title: 'Palary',
	teamName: 'Palary',
	cidaasClientId: null,
	cidaasBaseUrl: null,
	helpFaqUrl: null,
	hideFeedback: true,
};

const BrandThemeContext = createContext(defaultTheme);

export const BrandThemeProvider = ({ children }) => {
	const [theme, setTheme] = useState(defaultTheme);

	useEffect(() => {
		void fetch('/theme').then(res => res.json().then(data => setTheme(data)));
	}, []);

	return <BrandThemeContext.Provider value={theme}>{children}</BrandThemeContext.Provider>;
};

export const useBrandTheme = () => useContext(BrandThemeContext);
